import { useProcess } from '@react-query/hooks/query/use-process';
import './pending-process-details.scss';
import { DetailItem } from '@components/process-details/detail-item';
import { ProcessDetails } from '@components/process-details/process-details';
import { useTranslation } from '@translations';
import { getUserContextParentEmail } from '@utils/process-utils';

export const PendingProcessDetails = () => {
    const { data: process, isPending, isSuccess } = useProcess();
    const { processDetails } = useTranslation();

    if (!isSuccess) {
        return null;
    }

    const { child, applicantParent, approverParent, handoverAge, created } = process;

    return (
        <ProcessDetails isLoading={isPending} data-testid="pending-process-details" withTitle>
            <ProcessDetails.Section>
                <DetailItem.AboutAsk />
                <DetailItem.CreatedDate date={created} />
            </ProcessDetails.Section>
            <ProcessDetails.Section title={processDetails.ageLimits}>
                <DetailItem.PartialAccessAge />
                <DetailItem.HandoverAge handoverAge={handoverAge} />
            </ProcessDetails.Section>
            <ProcessDetails.Section title={processDetails.peopleConnected}>
                <DetailItem.AccountOwner name={child.name} />
                <DetailItem.Parents applicantName={applicantParent.name} approverName={approverParent.name} />
            </ProcessDetails.Section>
            <ProcessDetails.Section title={processDetails.contactInfo}>
                <DetailItem.ParentEmail email={getUserContextParentEmail(process)} />
                <DetailItem.ApproverParentPhoneNumber
                    name={approverParent.name}
                    phoneNumber={approverParent.phoneNumber}
                />
            </ProcessDetails.Section>
        </ProcessDetails>
    );
};
